/**
 * DevExtreme (ui/data_grid/ui.data_grid.core.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var extend = require("../../core/utils/extend").extend,
    gridCoreUtils = require("../grid_core/ui.grid_core.utils"),
    modules = require("../grid_core/ui.grid_core.modules");
extend(exports, modules, gridCoreUtils, {
    modules: []
});



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/data_grid/ui.data_grid.core.js
// module id = ../../../../devextreme/ui/data_grid/ui.data_grid.core.js
// module chunks = common